// apps/mcv-client/src/features/vault/dashboard/Dashboard.tsx
import { useContext } from 'react';
import { VaultNewRecordsContext } from '../newRecords/context';
import { AlertBanner } from './AlertBanner';
import { CategoryCard } from './CategoryCard';
import { newRecordsLink, newRecordTablesFor } from './newRecordTables';
import { SummaryStrip } from './SummaryStrip';
import { useDashboardSummary } from './useDashboardSummary';

const profileSuggestionsEnabled = Boolean(import.meta.env.VITE_FF_MCV_1356__PROFILE_SUGGESTIONS);

export const Dashboard = () => {
  const { alerts, completeness, quickStats, categories, loading, providerId } =
    useDashboardSummary();
  // [MCV-1812] Read-only: the dashboard shows which cards have New records but never marks them
  // seen. They clear when the provider opens that section.
  const { byTable } = useContext(VaultNewRecordsContext);

  return (
    <div data-cy="dashboard-layout" className="w-full px-2 sm:px-3 py-2">
      {/* Zone 1: Alert Banner */}
      <AlertBanner alerts={alerts} providerId={providerId} />

      {/* Zone 2: Summary Strip — Next Steps (left) + Quick Stats (right).
          MCV-1422: profile suggestions now live inside the CompletenessPanel,
          replacing the legacy full-width ProfileSuggestionsPanel below. */}
      <SummaryStrip
        completeness={completeness}
        quickStats={quickStats}
        loading={loading}
        providerId={providerId}
        profileSuggestionsEnabled={profileSuggestionsEnabled}
      />

      {/* Zone 3: Category Cards — order and full-width flag come from useDashboardSummary */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        {categories.map((category) => {
          const newTables = category.loading
            ? []
            : newRecordTablesFor(category.key, byTable, category.recordIdsByTable);
          return (
            <CategoryCard
              key={category.key}
              summary={
                newTables.length > 0
                  ? { ...category, navigateTo: newRecordsLink(category.navigateTo, newTables) }
                  : category
              }
              fullWidth={category.fullWidth}
              tallTwoRows={category.tallTwoRows}
              hasNewRecords={
                newTables.length > 0 || (!category.loading && Boolean(category.hasUploadToday))
              }
            />
          );
        })}
      </div>
    </div>
  );
};
